import React, { useContext } from 'react';
import { useAccordionToggle, AccordionContext, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const AccordionToggleWithButtonForRole = ({ children, eventKey, callback }) => {
  const currentEventKey = useContext(AccordionContext);

  const isCurrentEventKey = currentEventKey === eventKey;

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey, isCurrentEventKey)
  );

  return (
    <Button
      style={{
        top: '-10px',
        padding: '0px',
      }}
      className={`${
        isCurrentEventKey ? 'opened' : 'collapsed'
      } px-0 hd-accordion-button m-0 btn-sm btn-light`}
      onClick={decoratedOnClick}
    >
      {children}
    </Button>
  );
};

AccordionToggleWithButtonForRole.propTypes = {
  children: PropTypes.any,
  eventKey: PropTypes.any,
  callback: PropTypes.any,
};

export default AccordionToggleWithButtonForRole;
